import goods from '../en/goods'

const cnGoods = {}

for (const cn in goods) {
  cnGoods[cn] = cn
}

export default cnGoods
